export const VEHICLES_FETCH_REQUEST = "VEHICLES_FETCH_REQUEST";
export const VEHICLES_FETCH_SUCCESS = "VEHICLES_FETCH_SUCCESS";
export const VEHICLES_FETCH_FAIL = "VEHICLES_FETCH_FAIL";

export const VEHICLES_CLEAR_ERROR = "VEHICLES_CLEAR_ERROR";
